import { StatusIndicator } from '@/components/StatusIndicator';
import { reloadStatusMap } from '@/config/statusMaps';

/**
 * Result of the last nginx reload ("-" when never reloaded)
 */
export function ReloadStatusIndicator({ status }: { status: string | null }) {
  if (!status) {
    return <span className="nginx-status nginx-status-unknown">-</span>;
  }
  return <StatusIndicator status={status} map={reloadStatusMap} baseClassName="nginx-status" />;
}

/**
 * Active / inactive config badge
 */
export function ActiveBadge({ isActive }: { isActive: boolean }) {
  return (
    <span className={`nginx-active-badge ${isActive ? 'nginx-active-badge-yes' : 'nginx-active-badge-no'}`}>
      {isActive ? 'Active' : 'Inactive'}
    </span>
  );
}
